import { createFileRoute, Outlet } from '@tanstack/react-router'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { RouteErrorDisplay } from '@/components/RouteErrorDisplay'

// Layout route that renders child routes via Outlet
function ClassesLayout() {
  return <Outlet />
}

export const Route = createFileRoute('/app/classes')({
  component: ClassesLayout,
  errorComponent: ({ error }) => (
    <QueryErrorResetBoundary>
      {({ reset }) => <RouteErrorDisplay error={error} reset={reset} />}
    </QueryErrorResetBoundary>
  ),
})
